
import isM from 'ismobilejs';

export const isMountedReactApp = (): boolean => !!document.getElementById('bv-root-element')?.getAttribute('project-id');

export const isMobile = (): boolean => {
    return isM(window.navigator).phone;
};
export const isIosMobile = (): boolean => {
    return isM(window.navigator).apple.phone;
};
export const isTablet = (): boolean => {
    return isM(window.navigator).tablet;
};

export const isLandscape = (): boolean => window.matchMedia('(orientation: landscape)').matches;